import {
  CollapsibleFilterBuilder
} from 'onefaceui-react-components';
import PropTypes from 'prop-types';
import { getResourceTo } from 'react/utils/utils';
import { Container } from './RouteFilterStyles';

function RouteFilter({ filterState, onExpandChange}) {
  const {
    defaultValues,
    defaultSelected,
    handleFilterSubmit,
    filterBuilderFields,
    routeFieldsQuery
  } = filterState;

  return (
    <Container data-testid="routes-filter-container">
      <CollapsibleFilterBuilder
        defaultExpanded
        sectionTitleLabel={getResourceTo('route.gridindex')}
        dataTestId="filter-builder"
        defaultValues={defaultValues}
        defaultSelected={defaultSelected}
        onSubmit={handleFilterSubmit}
        fields={filterBuilderFields}
        hasExpandedAction={!routeFieldsQuery.isLoading}
        onToggleFilterSection={onExpandChange}
      />
    </Container>
  );
}

RouteFilter.propTypes = {
  filterState: PropTypes.object.isRequired,
  onExpandChange: PropTypes.func
};

export default RouteFilter;
